import React from "react";

import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";
import { Button, Icon, IconBox } from "@proda-ai/ui-kit";
import type { DealPropertyInfoWithId } from "../dealTypes";

export const testIds = {
    dealName: "DealOverviewTopBar-dealName",
    propertyAddress: "DealOverviewTopBar-propertyAddress",
    addDocumentButton: "DealOverviewTopBar-addDocumentButton",
};

type OverviewTopBarProps = {
    deal: DealPropertyInfoWithId;
    handleAddFileButtonClicked: () => void;
    handleBackButtonClicked: () => void;
};

const OverviewTopBar: React.FC<OverviewTopBarProps> = ({
    deal,
    handleAddFileButtonClicked,
    handleBackButtonClicked,
}) => {
    return (
        <Box
            sx={{
                fontSize: "1.2rem",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                padding: "1.5rem 1.5rem 0 1.5rem",
                width: "100%",
                gap: "0.5rem",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    gap: "0.2rem",
                    flexGrow: 1,
                    minWidth: "0",
                }}
            >
                <Typography
                    variant="h1"
                    sx={{
                        justifyContent: "flex-start",
                        gap: "0.3rem",
                        flexDirection: "row",
                        alignItems: "center",
                        display: "flex",
                    }}
                    data-testid={testIds.dealName}
                >
                    <Box
                        onClick={handleBackButtonClicked}
                        sx={{
                            padding: "0.2rem",
                            cursor: "pointer",
                        }}
                    >
                        <IconBox>
                            <Icon icon="chevron-left" />
                        </IconBox>
                    </Box>
                    {deal.dealName}
                </Typography>
                {deal.properties.length === 1 ? (
                    <Typography
                        variant="body2"
                        sx={{
                            color: "var(--proda-black-10)",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "0.3rem",
                            padding: "0.2rem",
                            maxWidth: "420px",
                        }}
                        data-testid={testIds.propertyAddress}
                    >
                        <IconBox>
                            <Icon icon={"location-dot"} />
                        </IconBox>
                        <Box
                            sx={{
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {`${deal.properties[0]?.propertyName}, ${deal.properties[0]?.fullAddress}`}
                        </Box>
                    </Typography>
                ) : (
                    <Typography
                        variant="body2"
                        sx={{
                            color: "var(--proda-black-10)",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "0.3rem",
                            padding: "0.2rem",
                            maxWidth: "420px",
                        }}
                        data-testid={testIds.propertyAddress}
                    >
                        <IconBox>
                            <Icon icon={"location-dot"} />
                        </IconBox>
                        <Box
                            sx={{
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {`${deal.properties.length} properties`}
                        </Box>
                    </Typography>
                )}
            </Box>
            <Button
                pattern="primary"
                size={"large"}
                isInline={true}
                onClick={handleAddFileButtonClicked}
                data-testid={testIds.addDocumentButton}
            >
                Upload Document
            </Button>
        </Box>
    );
};

export default OverviewTopBar;
